const FIREBASE_MESSAGING_SW_URL = "/firebase-messaging-sw.js";

let registrationPromise: Promise<ServiceWorkerRegistration> | null = null;

export function registerFirebaseMessagingServiceWorker(): Promise<ServiceWorkerRegistration> | null {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return null;
  }

  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker
      .register(FIREBASE_MESSAGING_SW_URL)
      .then((registration) => {
        window.addEventListener("online", () => {
          void registration.update();
        });
        return registration;
      })
      .catch((error) => {
        registrationPromise = null;
        console.error("❌ Firebase messaging service worker registration failed:", error);
        throw error;
      });
  }

  return registrationPromise;
}

export async function getFirebaseMessagingServiceWorkerRegistration(): Promise<ServiceWorkerRegistration> {
  const promise = registerFirebaseMessagingServiceWorker();

  if (!promise) {
    throw new Error("Service workers are not supported in this browser");
  }

  return promise;
}
